<template>
  <div v-if="basePlans">
    <PTabs :tabs="categoryTabs"
           :selected="category"
           align-left
           class="plan-tabs"
           @select="onSelectCategory"
           v-if="categoryTabs.length > 1"/>
    <BasePlanSwitcher
        :plans="basePlans"
        :trialPlan="trialPlan"
        :plan="chosenPlan"
        :currency="currency"
        @change="$emit('change', $event)"
        v-if="basePlans.length > 0"
    />
  </div>
</template>

<script>
import PTabs from "@/domain/core/components/PTabs.vue";
import BasePlanSwitcher from "@/domain/events/components/BasePlanSwitcher.vue";

export default {
  name: "CategorySelector",
  components: {BasePlanSwitcher, PTabs},
  emits: ['change', 'moveNext'],
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      required: true
    },
    selected: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      category: null,
      chosenPlan: null
    }
  },
  mounted() {
    for (const category of this.categories) {
      if (this.selected && category.base_plans.find(plan => plan.id === this.selected)) {
        this.category = category.name;
        return;
      }
    }
    if (!this.category)
      this.category = this.categoryTabs[0].name;
  },
  computed: {
    categoryTabs() {
      return this.categories
          .filter(category => !category.is_trial)
          .map(category => ({
          name: category.name,
          label: category.name,
        }));
    },
    basePlans() {
      if (!this.category) return []
      const category = this.categories.find(category => category.name === this.category)
      return [...category.base_plans].sort((a, b) => a.price - b.price)
    },

    trialPlan() {
      for (const category of this.categories) {
        const trialPlan = category.base_plans.find(plan => plan.is_trial === true);
        if (trialPlan) {
          return trialPlan;
        }
      }
      return null;
    }
  },
  methods: {
    async onSelectCategory(name) {
      this.category = name
    },
  }
}
</script>